<script>
import { Line, mixins, Scatter } from "vue-chartjs";
// https://github.com/chartjs/chartjs-adapter-luxon
// FIXME: import "chartjs-adapter-luxon";
const { reactiveProp } = mixins;

import { formatTimeDayOfWeek, formatTime12hr } from "@tod-ui/helpers/datetime";
import { DateTime } from "luxon";

export default {
  name: "IncidentWeeklyAverageReportChart",
  extends: Scatter,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: [Array, Object],
      default: null,
      required: true,
    },
    min: {
      type: [Number, String],
      default: 0,
    },
    max: {
      type: [Number, String],
      default: 500,
    },
    title: {
      type: String,
      default: undefined,
    },
    bucketsPerDay: {
      type: Number,
      required: true,
    },
  },
  mounted() {
    //Needed to access this value in the callback. Javascript is so good.
    const bpd = this.bucketsPerDay;
    const options = {
      responsive: true,
      maintainAspectRatio: false,
      tooltips: {
        callbacks: {
          label: function (tooltipItem, data) {
            let bucketsPerHour = 24 / bpd;
            let hourOfWeek = tooltipItem.index * bucketsPerHour;
            let date = DateTime.local();
            let startOfWeek = date.startOf("week");
            startOfWeek = startOfWeek.plus({ hours: hourOfWeek });

            if (bpd == 1) {
              return `${tooltipItem.value} events on ${formatTimeDayOfWeek(
                startOfWeek
              )}`;
            } else {
              return `${tooltipItem.value} events on ${formatTimeDayOfWeek(
                startOfWeek
              )} ${formatTime12hr(startOfWeek)}`;
            }
          },
          title: function (tooltipItem, data) {},
        },
      },
      scales: {
        xAxes: [
          {
            display: true,
            distribution: "linear",
            ticks: {
              min: 0,
              max: this.bucketsPerDay * 7 - 1,
              stepSize: 1,
              autoSkip: false,
              // reverse: true,
              callback: function (label, index, labels) {
                let pos = JSON.parse(JSON.stringify(label));
                pos += 1;
                if (pos % bpd == 0) {
                  let day = pos / bpd;
                  if (day == 1) {
                    return "Monday";
                  }
                  if (day == 2) {
                    return "Tuesday";
                  }
                  if (day == 3) {
                    return "Wednesday";
                  }
                  if (day == 4) {
                    return "Thursday";
                  }
                  if (day == 5) {
                    return "Friday";
                  }
                  if (day == 6) {
                    return "Saturday";
                  }
                  if (day == 7) {
                    return "Sunday";
                  }
                }
              },
            },
          },
        ],
        yAxes: [
          {
            ticks: {
              stepSize: 1,
              min: 0,
              max: this.max,
            },
          },
        ],
      },
    };

    this.renderChart(this.chartData, options);
  },
  methods: {},
};
</script>
